<template>
    <div class="header--survey">
        <div class="header--actions" v-if="pretitle != ''">
            <span class="header__pretitle">{{ pretitle }}</span>
            <!-- <router-link class="header__logout" :to="{ name: 'logout'}">logout</router-link> -->
        </div>
        <div class="header--feedback">
            <a v-if="stepProgress <= maxStepsCount" class="header--feedback__back" href="#" :class="{ visible: backLink }" @click.prevent="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
                    <g stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd">
                        <path d="M10.374 17.3L2 9 10.374.7M2 9h18"/>
                    </g>
                </svg>
            </a>
            <span v-if="stepProgress <= maxStepsCount" class="header--feedback__title">{{ title }}</span>
            <span v-else-if="surveyAlreadyCompleted" class="header--feedback__title">Oops</span>
            <span v-else class="header--feedback__title">{{ $t('thank_you') }}</span>
            <span v-if="stepProgress > 0 && stepProgress <= maxStepsCount" class="header--feedback__progress">{{ stepProgress }}/{{ maxStepsCount }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            backLink: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: null
            },
            pretitle: {
                type: String,
                default: null
            },
            stepProgress: {
                type: Number,
                default: null
            },
            maxStepsCount: {
                type: Number,
                default: null
            },
            surveyAlreadyCompleted: {
                type: Boolean
            },
        },

        methods: {
            goBack() {
                /* (this.title === 'Checking In' || this.title === 'Vakai atu' ) ? this.$emit('goBack') : this.$router.go(-1) */
                /* this.title === 'Checking In' ? this.$emit('goBack') : this.$router.go(-1) */
                this.$emit('goBack');
            }
        },
    }
</script>
